import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@utils/cn';
const tabs = [
    { id: 'hot', label: '热门' },
    { id: 'latest', label: '最新' },
    { id: 'top', label: '高赞' },
];
export function ContentTabs({ activeTab, onTabChange }) {
    return (_jsx("div", { className: "mb-6 flex gap-4 border-b border-gray-200", children: tabs.map((tab) => (_jsxs("button", { onClick: () => onTabChange(tab.id), className: cn('relative px-4 py-3 font-medium transition-colors', activeTab === tab.id
                ? 'text-primary-500'
                : 'text-gray-600 hover:text-gray-900'), children: [tab.label, activeTab === tab.id && (_jsx("div", { className: "absolute bottom-0 left-0 right-0 h-0.5 bg-primary-500" }))] }, tab.id))) }));
}
